import {
  FaArrowCircleRight,
  FaArrowUp,
  FaAward,
  FaBan,
  FaCalendar,
  FaCalendarAlt,
  FaCalendarDay,
  FaCheck,
  FaCheckCircle,
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight,
  FaClock,
  FaClone,
  FaCog,
  FaEnvelope,
  FaExclamationTriangle,
  FaEye,
  FaFilter,
  FaGraduationCap,
  FaInfoCircle,
  FaList,
  FaPencilAlt,
  FaPhone,
  FaPlus,
  FaSave,
  FaSpinner,
  FaTimes,
  FaTrash,
  FaUser,
  FaUserGraduate,
  FaUsers,
  FaLock,
  FaArrowDown,
  FaChartBar,
  FaBars,
  FaSignOutAlt,
  FaFileImport,
  FaFileExport,
  FaFile,
  FaBell,
  FaHandHoldingHeart,
  FaUserPlus,
  FaHourglassHalf,
  FaCommentSlash,
  FaUserSlash,
} from "react-icons/fa";
import { FaBoltLightning, FaCircleCheck } from "react-icons/fa6";

export const Icons = {
  Add: FaPlus,
  ArrowDown: FaArrowDown,
  Award: FaAward,
  BarChart: FaChartBar,
  Blocked: FaBan,
  Calendar: FaCalendarAlt,
  Cancel: FaBan,
  ChangeLog: FaBoltLightning,
  Check: FaCheck,
  CheckCircle: FaCheckCircle,
  ChevronDown: FaChevronDown,
  ChevronLeft: FaChevronLeft,
  ChevronRight: FaChevronRight,
  Clock: FaClock,
  Close: FaTimes,
  Competition: FaAward,
  Date: FaCalendar,
  Delete: FaTrash,
  Edit: FaPencilAlt,
  Email: FaEnvelope,
  Event: FaCalendarDay,
  Export: FaFileExport,
  File: FaFile,
  Filter: FaFilter,
  GroupLesson: FaUsers,
  Import: FaFileImport,
  Info: FaInfoCircle,
  Lesson: FaGraduationCap,
  List: FaList,
  Loading: FaSpinner,
  Lock: FaLock,
  LogOut: FaSignOutAlt,
  Menu: FaBars,
  Phone: FaPhone,
  PrivateLesson: FaUserGraduate,
  Remove: FaArrowUp,
  Repeat: FaArrowCircleRight,
  Save: FaSave,
  Settings: FaCog,
  Template: FaClone,
  User: FaUser,
  Member: FaUserPlus,
  Users: FaUsers,
  View: FaEye,
  Warning: FaExclamationTriangle,
  X: FaTimes,
  Teacher: FaGraduationCap,
  BoardMember: FaBell,
  Helper: FaHandHoldingHeart,
  AppIcon: FaCalendarDay,
  Obverver: FaEye,
  Pending: FaHourglassHalf,
  Present: FaCircleCheck,
  Cancelled: FaBan,
  Unjustified: FaCommentSlash,
  Excluded: FaUserSlash,
};

export const renderIcon = (Icon, props = {}) => {
  return <Icon {...props} />;
};

export default Icons;
